module.exports = "https://static.wmbcdn.com/uniweb/images/6e2d7fd71a4ca2a5ce77c191d8537682.svg";